import { Button } from '@mantine/core'
import MapControlBox from './MapControlBox'
import { TbHome } from 'react-icons/tb'
import { modals } from '@mantine/modals'
import { Text } from '@mantine/core'

const RefreshDirectionsToGarageButton = ({ onRefresh }: { onRefresh: () => void }) => {
  const confirmationModal = () =>
    modals.openConfirmModal({
      title: (
        <Text size="xl" w={700}>
          Upozornění
        </Text>
      ),
      children: (
        <Text size="xl" style={{ fontSize: 24, textAlign: 'center' }}>
          Opravdu chcete navigovat do garáže?
        </Text>
      ),
      labels: { confirm: 'Ano, chci jet do garáže', cancel: 'Ne, chci pokračovat' },
      onCancel: () => {},
      onConfirm: onRefresh,
      size: 'lg',
      centered: true,
      styles: {
        title: { fontSize: 28, fontWeight: 'bold' },
        body: { fontSize: 24 },
      },
      zIndex: 10001,
    })

  return (
    <MapControlBox position="left" style={{ top: 110 }}>
      <Button
        color="gray"
        variant="filled"
        onClick={e => {
          e.stopPropagation()
          confirmationModal()
        }}
        styles={{
          root: {
            height: 60,
            borderRadius: 64,
            padding: '0 10px',
            fontSize: 40,
          },
        }}
      >
        <TbHome />
      </Button>
    </MapControlBox>
  )
}

export default RefreshDirectionsToGarageButton
